export default class FloatingButton extends HTMLAnchorElement {

    observer = null;

    connectedCallback() {

        let options = {
            rootMargin: this.dataset.margin || "200px",
            threshold: this.dataset.threshold || 0,
        };

        this.observer = new IntersectionObserver(this.intersectionCallback, options);
        this.observer.observe(this.targetElement);

    }

    disconnectedCallback() {

        this.observer.unobserve(this.targetElement);
        
    }

    intersectionCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.classList.remove("floating-button-show");
            } else {
                this.classList.add("floating-button-show");
            }
        });
    }

    get targetElement() {
        return document.querySelector(`${this.getAttribute("href")}`);
    }

}

customElements.define('floating-button', FloatingButton, { extends: 'a' });